export enum GtmCustomEvents {
  CLIENT_REGISTRATION = 'client-registration',
  CLIENT_SAM_SIGNUP = 'client-sam-signup',
  MATCH_FLOW = 'match-flow',
  MATCH_FLOW_DEFAULT = 'match-flow-default',
  CAL_CONNECT_CLICKED = 'calendar-events',
  CAL_EVENT_CLICKED = 'calendar-event-clicked',
  CTA_ELEMENT_CLICKED = 'cta-element-clicked',
  USER_SETTINGS_DEFAULT_FONT_SIZE = 'user-settings-default-font-size',
  CLIENT_VIDEO_SESSION_LAUNCHED = 'video-session',
  CLIENT_ACCOUNT_COMPLETE = 'client-account-complete',
  CLIENT_THERAPY_READINESS = 'client-therapy-readiness',
  CLIENT_CLAIM_SUBMITTED = 'client-claim-submitted',
  PROVIDER_PAGE_VIEW = 'provider-page-viewed'
}

export enum GtmIntakeActions {
  SETUP_COMPLETE = 'Setup Complete',
  SUBMIT_THERAPY_READINESS = 'Submit Ready for Therapy',
  CLAIM_SUBMITTED = 'Claim Submitted for Client'
}

export enum GtmSamActions {
  OPEN_DASHBOARD_CTA = 'Open Dashboard CTA',
  OPEN_JOIN_REQUEST_CTA = 'Open Provider Join Request CTA',
  OPEN_CHAT_CTA = 'Open Chat CTA',
  OPEN_BANNER_LINK = 'Open Banner Link',
  OPEN_BILLING_LINK = 'Open Billing Link',
  OPEN_CHAT_REDIRECT = 'Open Chat Redirect',
  OPEN_CHAT_REDIRECT_WITH_INCENTIVE_BADGE = 'Open Chat Redirect with Incentive Badge',
  OPEN_LEARN_MORE = 'Open Learn More',
  OPEN_NO_MATCHED_PROVIDER = 'Open No Matched Provider',
  OPEN_NO_PROVIDER_IN_SAM = 'Open No Provider In SAM',
  OPEN_SAM_PROVIDER_REQUEST = 'Open Start SAM Provider Request',
  OPEN_SIGNUP_DISABLED = 'Landed at Signup Disabled Screen',
  CLICK_CONFIRM_SAM_PROVIDER_REQUEST = 'Click Confirm SAM Provider Request',
  CLICK_CONNECT_NEW_THERAPIST = 'Click Connect With New Therapist',
  VIEW_OLD_MESSAGES = 'Click View Old Messages',
  OPEN_SIGN_UP = 'Open Sign Up',
  OPEN_SELECT_PROVIDER = 'Open Select Provider',
  OPEN_CONFIRM_CREDIT_CARD = 'Open Confirm Credit Card',
  CLICK_SUBSCRIBE_NOW = 'Click Subscribe Now',
  CLICK_BACK = 'Click Back',
  CLOSE_MODAL = 'Close Signup Modal'
}

export enum GtmExternalCalActions {
  CLICK_ADD_EXTERNAL_CALS = 'Click button to add an external calendar',
  SUCCESSFULLY_CONNECT_EXTERNAL = 'Successfully connected external calendar',
  ERROR_CONNECTING_EXTERNAL = 'Error connecting to external calendar',
  CLICK_EXTERNAL_EVENT = 'Clicked on an external event',
  CLICK_EVENT = 'Clicked an internal event',
  DISCONNECT_EXTERNAL_CAL = 'Disconnected an external calendar'
}
